import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "table1"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  key: 3
};
const _hoisted_6 = {
  key: 4
};
const _hoisted_7 = {
  key: 5
};
import { computed } from 'vue';
import { appStatus, appType } from '../config';
import { indexMethod } from '@/utils/indexMethod';
export default {
  __name: 'table',
  props: {
    data: {
      type: Array
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 8
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableSchemas: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update', 'dup', 'open', 'down', 'del', 'replace'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleUpdate = row => {
      emit('update', row);
    };
    const handleDup = row => {
      emit('dup', row);
    };
    const handleOpen = row => {
      emit('open', row);
    };
    const handleDown = row => {
      emit('down', row);
    };
    const handleDel = row => {
      emit('del', row);
    };
    const handleReplace = row => {
      emit('replace', row);
    };
    const formatFileName = computed(() => {
      return fileName => {
        return fileName;
      };
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: __props.data,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          index: index => _unref(indexMethod)(index, __props.currentPage, __props.pageSize),
          align: "center",
          "min-width": 40
        }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableSchemas, (item, index) => {
          return _openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.label,
            "min-width": item.minWidth,
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [item.prop === 'createTime' ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$filters.dateFilter(row[item.prop])), 1)) : item.prop === 'type' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_tag, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(appType)[row[item.prop]]), 1)]),
              _: 2
            }, 1024)])) : item.prop === 'fileName' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(formatFileName.value(row[item.prop])), 1)) : item.prop === 'applyStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tag, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(appStatus)[row[item.prop]]), 1)]),
              _: 2
            }, 1024)])) : item.prop === 'action' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.btnArr, (item, index) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: index
              }, [item === 'update' && row['applyStatus'] !== 2 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                size: "small",
                onClick: $event => handleUpdate(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'dup' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "success",
                size: "small",
                onClick: $event => handleDup(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 复制 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'open' && row['applyStatus'] !== 2 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "primary",
                size: "small",
                onClick: $event => handleOpen(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 上架 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'down' && row['applyStatus'] !== 1 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "warning",
                size: "small",
                onClick: $event => handleDown(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 下架 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'delete' && row['applyStatus'] !== 2 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                type: "danger",
                size: "small",
                onClick: $event => handleDel(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item === 'replace' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                type: "primary",
                size: "small",
                onClick: $event => handleReplace(row)
              }, {
                default: _withCtx(() => [_createTextVNode(" 替换 ")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row[item.prop]), 1))]),
            _: 2
          }, 1032, ["label", "min-width"]);
        }), 128))]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, __props.loading]])]);
    };
  }
};